export const SYSTEM_WIDE_OUTAGE = "System Wide Outage";

export enum Category {
  SA = "Sponsored ads",
  ADSP = "Amazon DSP",
  MR = "Measurement & Reporting",
  BrandContent = "Brand content",
  AMS = "Amazon Marketing Stream",
  "System Wide Outage" = "Status announcement",
}

export enum SubCategory {
  AdDelivery = 'Ad delivery',
  CampaignCreation = 'Campaign creation',
  CampaignManagement = 'Campaign management',
  CreativeManagement = 'Creative management',
  Reports = 'Reports',
  Outage = 'System Wide Outage',
  Posts = 'Posts',
  Stores = 'Stores',
  Bulksheets = 'Bulksheets',
  Streams = 'Streams'
}

export type CategoryKeys = keyof typeof Category;